import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const DialogPortal = (props: ComponentProps<typeof DialogPrimitive.Portal>) => (
  <DialogPrimitive.Portal data-slot="dialog-portal" {...props} />
);
